import script from "./project-index.vue?vue&type=script&setup=true&lang=js"
export * from "./project-index.vue?vue&type=script&setup=true&lang=js"

import "./project-index.vue?vue&type=style&index=0&id=af2dacf2&lang=css"

const __exports__ = script;

export default __exports__